import { gql } from 'apollo-angular'

export default gql`
  mutation edit_study_by_pk($id: Int!, $_set: study_set_input) {
    update_study(where: { id: { _eq: $id } }, _set: $_set) {
      affected_rows
      returning {
        id
      }
    }
  }
`
